<template>
  <page-outline :title="$t('contacts.contact_details')"
    iconFA="address-book">
    <template slot="pageContent">
      <b-row>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.type_label')" :inputValue="typeContact">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.nme')" :inputValue="username">
          </form-read-group-label-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.als')" :inputValue="label">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group"
          v-if="this.$settings.currentContact.typeContact === '1'">
          <form-read-group-label-input
            :inputLabel="$t('common.eml')" :inputValue="identifier">
          </form-read-group-label-input>
        </b-col>
      </b-row>

      <b-row v-if="this.$settings.currentContact.typeContact === '2'">
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.srn')" :inputValue="identifier">
          </form-read-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" class="form-group"
          v-for="bankData in extractedBankData" :key="bankData.labelId">
          <form-read-group-label-input
            :inputLabel="$t(bankData.labelId)" :inputValue="bankData.value">
          </form-read-group-label-input>
        </b-col>
      </b-row>


      <b-row v-if="this.$engine.user.currentService.id === '2'">
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('bank_accounts.mandat_id')" :inputValue="''">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('bank_accounts.mandat_date')" :inputValue="''">
          </form-read-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.phn_nbr')" :inputValue="phoneNumber">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.adrs')" :inputValue="address">
          </form-read-group-label-input>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.cty')" :inputValue="city">
          </form-read-group-label-input>
        </b-col>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.zp_code')" :inputValue="zipCode">
          </form-read-group-label-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6" class="form-group">
          <form-read-group-label-input
            :inputLabel="$t('common.cntry')" :inputValue="country">
          </form-read-group-label-input>
        </b-col>
      </b-row>
    </template>
    <template slot="footerButtons">
      <b-row class="justify-content-start">
        <b-col md="3" offset-md="5" class="form-group">
          <f7-button class="button-action milkyBlockBlack"
            href="/account/editContact/"
            :disabled="!canEditContact">
            <f7-icon f7="edit"></f7-icon>
            <span>
              {{ $t('contacts.edit_contact') }}
            </span>
          </f7-button>
        </b-col>
        <b-col md="3" class="form-group">
          <f7-button
            class="button-action milkyBlockBlack"
            :title="$t('common.rm_label')"
            @click="removeContact"
            :disabled="!canRemoveContact">
            <f7-icon f7="close_round_fill"></f7-icon>
            <span>{{ $t('contacts.supp_contact') }}</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {extractForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      id: '',
      identifier: '',
      username: '',
      extractedBankData: {},
      label: '',
      phoneNumber: '',
      address: '',
      city: '',
      zipCode: '',
      country: '',
      typeContact: '',
      zone: '',
      accountLabel: {},
      canEditContact: false,
      canRemoveContact: false
    }
  },
  created () {
    this.id = this.$settings.currentContact.id
    this.username = this.$settings.currentContact.name
    this.identifier = this.$settings.currentContact.identifier
    this.label = this.$settings.currentContact.label
    this.phoneNumber = this.$settings.currentContact.phoneNumber
    this.typeContact = (this.$settings.currentContact.typeContact === '1' ? 'Individual' : 'Company')
    this.address = this.$settings.currentContact.address
    this.city = this.$settings.currentContact.city
    this.zipCode = this.$settings.currentContact.zipCode
    this.country = this.$settings.currentContact.country
    this.zone = this.$settings.currentContact.zoneCode
    this.accountLabel = this.$engine.bankAccounts.getAccountLabel(this.zone)

    if (this.$settings.currentContact.iban !== '' && this.zone !== '') {
      this.extractedBankData = extractForeignIban(this.$settings.currentContact.iban, this.zone)
    }
    let that = this
    if (that.$engine.user.get().id === that.$engine.user.get().userAccountId) {
      this.$engine.rights.getAdminRights().then(resp => {
        that.canRemoveContact = resp.rights.contact_supprimer.state === '1'
        that.canEditContact = resp.rights.contact_editer.state === '1'
      })
    } else {
      this.$engine.rights.getPersonnalRights().then(resp => {
        that.canRemoveContact = resp.rights.contact_supprimer.state === '1'
        that.canEditContact = resp.rights.contact_editer.state === '1'
      })
    }
  },
  methods: {
    removeContact () {
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('common.oper_confirm'),
        text: this.$i18n.t('contacts.contact_deletion_confirm'),
        buttons: [{
          text: that.$t('common.cncl'),
          onClick: function () {
            // that.$f7.closeModal()
          }
        }, {
          text: 'OK',
          onClick: function () {
            that.$engine.contacts
            .delete(that.$settings.currentContact.id)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('contacts.cntcts_dltd'),
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.identifier = ''
                that.username = ''
                that.$f7.closeModal()
                that.$bus.$emit('refresh-cache-contacts')
                loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
              }, 2000)
            })
            .catch(err => {
              this.handleError(err) // mixins errorHandlerMixins
            })
          }
        }]
      })
    },
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('email')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
        } else {
          that.Dom7($event.target).next().hide()
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
        } else {
          that.Dom7($event.target).parent().next().hide()
        }
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// CMContactDetail.vue?59816d94